import type { BrandedQuoteModule } from 'types/capi/article';
import { Palette } from 'types/capi/modules';

import { CloseQuoteMark, OpenQuoteMark } from '~/assets/icons/QuoteMarks';

type Props = {
  quote: BrandedQuoteModule;
};

function QuoteMark({ theme, type }: { theme: Palette; type: 'start' | 'end' }) {
  return (
    <div
      className="flex size-8 items-center justify-center border border-black"
      style={{ backgroundColor: theme.background, borderColor: theme.border }}
    >
      {type === 'start' ? (
        <OpenQuoteMark width={16} height={20} fill={theme.foreground} />
      ) : (
        <CloseQuoteMark width={16} height={20} fill={theme.foreground} />
      )}
    </div>
  );
}

export function BrandedQuoteCore({ quote }: Props) {
  return (
    <>
      <div className="flex w-full justify-start">
        <QuoteMark theme={quote.speech_marks.start.light} type="start" />
      </div>

      <p className="w-full text-center font-heading text-2xl font-medium leading-8 -tracking-wider md:text-[32px] lg:leading-10">
        {quote.text}
      </p>

      <div className="flex w-full justify-end">
        <QuoteMark theme={quote.speech_marks.end.light} type="end" />
      </div>
    </>
  );
}

export default function BrandedQuote({ quote }: Props) {
  return (
    <blockquote className="mx-auto flex max-w-full flex-col gap-2 px-4 md:max-w-[776px] lg:max-w-[936px]">
      <BrandedQuoteCore quote={quote} />
    </blockquote>
  );
}
